import { TenantSearchFormValues } from '@/features/tenant'
import { Search as SearchIcon } from '../../../../icons'
import { Box, InputAdornment, SvgIcon, TextField } from '@mui/material'
import { useFormikContext } from 'formik'
import React, { FC, useCallback, useMemo } from 'react'
import { tenantSearchFormDefaultValues } from './TenantSearchFormContext'

type SearchBarProps = {
  placeholder: string
}

export const TenantSearch: FC<SearchBarProps> = ({ placeholder }) => {
  const { values, handleChange, touched, setFieldValue } = useFormikContext<TenantSearchFormValues>()

  const handleChangeAndResetPage = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(e)
      setFieldValue('page', tenantSearchFormDefaultValues.page)
    },
    [handleChange, setFieldValue],
  )

  return useMemo(
    () => (
      <Box sx={{ width: '400px' }}>
        <TextField
          fullWidth
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon color="action" sx={{ width: 18, height: 18 }}>
                    <SearchIcon />
                  </SvgIcon>
                </InputAdornment>
              ),
              sx: {
                height: '42px',
                padding: '8px 12px',
                alignItems: 'center',
                '& .MuiInputAdornment-positionStart': { marginRight: '10px' },
                '& input': { padding: 0 },
              },
            },
          }}
          placeholder={placeholder}
          variant="outlined"
          name="name"
          value={values.name}
          onChange={handleChangeAndResetPage}
          error={touched.name}
          helperText={touched.name}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
            },
          }}
        />
      </Box>
    ),
    [values, handleChange, touched, handleChangeAndResetPage],
  )
}
